import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d4d52ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-bar-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "nav-bar__fab-wrapper"
}
const _hoisted_3 = { class: "nav-bar" }
const _hoisted_4 = ["set"]
const _hoisted_5 = {
  key: 0,
  class: "nav-bar-content__main-navigation"
}

import FloatingActionButton from '@/common/components/snedson-material-components/floating-action-button/floating-action-button.vue';
import NavigationItem from '@/common/components/snedson-material-components/navigation-item/navigation-item.vue';
import { NavigationItems } from '@/router/useNavigation';
import { Pages } from '@/views/pages/usePages';
import router from '@/router';
import { computed } from 'vue';
import { animationState } from '@/services/animation-service/animation-state.ts';
import { HandleAnimation } from '@/services/animation-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'navigation-bar',
  setup(__props) {

const navigate = (newId: number, routeName: string) => {
    animationState.flow = HandleAnimation(
        'horizontal',
        currentItemId.value,
        newId
    );

    router.push({ name: routeName });
};


const currentItemId = computed(() => {
    return NavigationItems[router.currentRoute.value.meta.role].mainNavigationElements.find(x =>
        router.currentRoute.value.name?.toString().startsWith(x.routeName)
    )?.id ?? 0;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$route.name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_Transition, { name: "nav-bar__fab-transition" }, {
            default: _withCtx(() => [
              (_unref(Pages)[_ctx.$route.name.toString()].fabData)
                ? (_openBlock(), _createBlock(FloatingActionButton, {
                    key: 0,
                    props: {
                        size: 'large',
                        type: 'primary',
                        iconName: _unref(Pages)[_ctx.$route.name.toString()].fabData!.iconName,
                        shadowed: true
                    },
                    class: "nav-bar__fab",
                    onClick: _unref(Pages)[_ctx.$route.name.toString()].fabData!.callback
                  }, null, 8, ["props", "onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "nav-bar-content nav-bar__nav-bar-content",
        set: _ctx.currentRole = _ctx.$route.meta.role
      }, [
        (_ctx.$route.name)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(NavigationItems)[_ctx.currentRole].mainNavigationElements, (item) => {
                return (_openBlock(), _createBlock(NavigationItem, {
                  props: {
                            iconName: item.iconName,
                            title: item.title,
                            selected: _ctx.$route.name.toString().startsWith(item.routeName)
                        },
                  key: item.id,
                  onClick: ($event: any) => (navigate(item.id, item.routeName))
                }, null, 8, ["props", "onClick"]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(NavigationItems)[_ctx.currentRole].additionalNavigationElements, (item) => {
                return (_openBlock(), _createBlock(NavigationItem, {
                  props: {
                            iconName: item.iconName,
                            title: item.title,
                            selected: _ctx.$route.name.toString().startsWith(item.routeName),
                        },
                  key: item.id,
                  onClick: ($event: any) => (navigate(item.id, item.routeName))
                }, null, 8, ["props", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_4)
    ])
  ]))
}
}

})